import { render, staticRenderFns } from "./growthStageManagement.vue?vue&type=template&id=d5f01cc0&scoped=true"
import script from "./growthStageManagement.vue?vue&type=script&lang=js"
export * from "./growthStageManagement.vue?vue&type=script&lang=js"
import style0 from "./growthStageManagement.vue?vue&type=style&index=0&id=d5f01cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f01cc0",
  null
  
)

export default component.exports